import React from "react";

// Renders the A.V.R.A.H. wordmark in Nasalization wherever it appears in the string.
// Per Voice and Tone: non-legal customer-facing brand mentions are required to be in Nasalization.
const Brand = ({ children }) => {
  if (typeof children !== "string") return children;
  const parts = children.split(/(A\.V\.R\.A\.H\.)/);
  return (
    <>
      {parts.map((part, i) =>
        part === "A.V.R.A.H." ? (
          <span
            key={i}
            aria-label="Avrah"
            style={{
              fontFamily: '"Nasalization", -apple-system, BlinkMacSystemFont, sans-serif',
              letterSpacing: "0.04em",
            }}
          >
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
};

export default Brand;
